import { render, staticRenderFns } from "./AccionesModalNuevo.vue?vue&type=template&id=5d5e2bdb&scoped=true&"
import script from "./AccionesModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./AccionesModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./AccionesModalNuevo.vue?vue&type=style&index=0&id=5d5e2bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e2bdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d5e2bdb', component.options)
    } else {
      api.reload('5d5e2bdb', component.options)
    }
    module.hot.accept("./AccionesModalNuevo.vue?vue&type=template&id=5d5e2bdb&scoped=true&", function () {
      api.rerender('5d5e2bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mantenedores/AccionesModalNuevo.vue"
export default component.exports